import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroModern from '../components/HeroModern';
import WelcomeModern from '../components/WelcomeModern';
import PrenotaSection from '../components/PrenotaSection';
import GlutenFree from '../components/GlutenFree';
import TestimonialsModern from '../components/TestimonialsModern';
import BardasciaModern from '../components/BardasciaModern';
import LavoraConNoi from '../components/LavoraConNoi';
import FooterModern from '../components/FooterModern';

const Home = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation scrolled={scrolled} />
      <HeroModern />
      <WelcomeModern />
      <PrenotaSection />
      <GlutenFree />
      <TestimonialsModern />
      <BardasciaModern />
      <LavoraConNoi />
      <FooterModern />
    </div>
  );
};

export default Home;
